import { Box, Card, Grid, Modal, Typography, IconButton, Button } from '@mui/material';
import React, { useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { styles } from '../../styles/styles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SendIcon from '@mui/icons-material/Send';
import BlockIcon from '@mui/icons-material/Block';
import SearchIcon from '@mui/icons-material/Search';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { FontStyles } from '../../styles/FontStyles';

const DemoVideo = () => {
    const [demovideopopup, setDemovideoPopup] = useState(false);

    const handleClose = () => setDemovideoPopup(false);

    return (
        <>
            <Box>
                <Header />
            </Box>
            <Box
                sx={{
                    marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%", xl: "10%" },
                    marginBottom: "5%"
                }}
            >
                <Card
                    sx={{
                        ...styles.aboutcard,
                        boxShadow: 3,
                    }}
                >
                    <DecorativeCorner sx={{ top: -20, left: -20 }} />
                    <DecorativeCorner sx={{ top: -20, right: -20 }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                    <Typography variant="h4" component="h1" sx={styles.heading}>
                        Demo Video's Annapurna Marriages
                    </Typography>
                    <Card
                        sx={{
                            ...styles.aboutCard,
                            boxSizing: "border-box",
                            padding: "30px",

                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >

                                    <MenuBookIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to Login & Logout in AnnapurnaMarriages website ?
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >
                                    <ModeEditOutlineOutlinedIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to edit & view profile Annapurna Marriages website ?
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >
                                    <SearchIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to search profiles based on criteria ?
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >
                                    <FavoriteIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to shortlist profiles AnnapurnaMarriages website ?
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >
                                    <SendIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to send interest to profiles ?
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >
                                    <BlockIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to blocklist profiles in Annapurna Marriages website ?
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        ...styles.demovideo,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                    onClick={() => setDemovideoPopup(true)}
                                >
                                    <ThumbUpIcon sx={{ color: "#C1721F", width: "150px", height: "150px" }} />
                                    <Typography sx={{ ...FontStyles.DemoVideobottomText }}>
                                        How to approve your account ?
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                </Card>
            </Box>
            <Modal
                open={demovideopopup}
                onClose={handleClose}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box sx={{ position: "relative", display: "inline-block" }}>
                    <Button
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: "-15px",
                            right: { xs: "-0px", md: "-10%" },
                            minWidth: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            backgroundColor: "#C1721F",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "14px",
                            padding: 0,
                            zIndex: 10,
                            "&:hover": {
                                backgroundColor: "#a55817",
                            },
                        }}
                    >
                        X
                    </Button>

                    <Card
                        sx={{
                            ...styles.demopopup,
                            boxSizing: "border-box",
                            padding: "30px",
                            width: { xs: "80%", sm: "600px" },
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                height: { xs: "auto", md: "400px" },
                                position: "relative",
                            }}
                        >
                            <video
                                width="100%"
                                height="100%"
                                controls
                                poster="/path-to-thumbnail.jpg"
                                style={{ objectFit: "cover" }}
                            >
                                <source
                                    src="https://www.annapurnamarriages.com/uploads/ANNAPURNAMARRIAGESGNT_1.mp4"
                                    type="video/mp4"
                                />
                                not support the video
                            </video>
                        </Box>
                    </Card>
                </Box>
            </Modal>
            <Footer />
        </>
    );
}

export default DemoVideo;
